import React from 'react';

export default class HorizontalScroll extends React.Component {
    render() {
        return (
            <div className={[this.props.className].join(' ')} style={{overflowX: 'auto'}}>
                {this.props.children}
            </div>
        );
    }
}
